import { Alert, message } from "antd";
import axiosInstance from "../shared/axios";

const getServicesLookUp = async () => {
  try {
    let result = await axiosInstance.get("/servicesLookUps");
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading services");
      return null;
    }
  } catch (error) {
    message.error("Error while loading services");
    return null;
  }
};

const addEditService = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/updateService" : "/createService",
      { ...payload, id: id || null },
    );
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false, message: result?.data?.message };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save service",
    };
  }
};

const deleteService = async (id) => {
  try {
    const result = await axiosInstance.delete(`/deleteService/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete service",
    };
  }
};

export const servicesService = {
  getServicesLookUp,
  addEditService,
  deleteService,
};
